import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import {
  formatAccountStatus,
  formatBoolFromNumber,
  formatDateTime,
  formatDetailValue,
  formatPhone,
  formatStoreVisibilityStatus,
  formatVisibility,
  titleCase,
} from '../storeDetailsUtils';

export function StoreProfileSection({ meta, store }) {
  const op = store?.kitchen_operation ?? {};

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      {op.display_image ? (
        <div className="store-details-logo-block">
          <div className="store-details-logo-block__title">Store logo</div>
          <img
            src={op.display_image}
            alt={`${op.display_name || store.kitchenName} logo`}
            className="store-details-logo-block__image"
          />
        </div>
      ) : null}

      <div style={detailGrid2}>
        <DetailReadOnlyField label="Kitchen name" value={store.kitchenName} />
        <DetailReadOnlyField label="Display name" value={op.display_name} />
        <DetailReadOnlyField
          label="Owner name"
          value={[store.firstName, store.lastName].filter(Boolean).join(' ') || '—'}
        />
        <DetailReadOnlyField label="Email" value={store.email} />
        <DetailReadOnlyField label="Phone" value={formatPhone(store.phone_no)} />
        <DetailReadOnlyField label="Account type" value={titleCase(store.account_type)} />
        <DetailReadOnlyField label="Cuisine" value={titleCase(store.cuisine)} />
        <DetailReadOnlyField label="Referral no." value={store.referral_no} />
        <DetailReadOnlyField label="Package plan" value={titleCase(store.package_plan || op.merchant_package?.package_plan)} />
        <DetailReadOnlyField label="Account status" value={formatAccountStatus(store.status)} />
        <DetailReadOnlyField
          label="Email verified"
          value={formatBoolFromNumber(store.email_verified_status)}
        />
        <DetailReadOnlyField
          label="Store visibility"
          value={formatStoreVisibilityStatus(store.store_visibility_status)}
        />
        <DetailReadOnlyField label="Operation visibility" value={formatVisibility(op.visibility)} />
        <DetailReadOnlyField label="Managing branch" value={store.managing_branch_name} />
        <DetailReadOnlyField label="Company name" value={op.companyName} />
        <DetailReadOnlyField label="Contract type" value={op.contract_type} />
        <DetailReadOnlyField label="Total products" value={formatDetailValue(store.total_products)} />
        <DetailReadOnlyField label="Total addresses" value={formatDetailValue(store.total_addresses)} />
        <DetailReadOnlyField label="IP address" value={store.IP_address} />
        <DetailReadOnlyField label="Created at" value={formatDateTime(store.create_at)} />
      </div>
    </>
  );
}
